const POS_IMAGES = {
  petpooja: require('./petpooja.png').default, 
  urban_piper:  require('./urban_piper.png').default, 
  cashier_icon: require('./cashier.png').default, 
  success_monitor: require('./success_tv.png').default, 
  support_team: require('./support_team.png').default, 
}
  

export default POS_IMAGES